import { useApiQuery } from '../../../hooks/useApiQuery'
import { planningApi, type PlanningMe } from '../../../services/api/domains/planning.api'

/** The slice of useAuth().user this probe reads. */
export interface PlanningApplicantProbe {
  isGuest?: boolean
  licenses: readonly string[]
}

/**
 * Whether the signed-in user is a Planning applicant (spec section 7.1: a guest in the applicant
 * group). Only a guest on a tenant holding planning is asked, with one GET /planning/me; a 403
 * not_planning_actor, or any failure, means "not an applicant".
 */
export function usePlanningApplicant(user: PlanningApplicantProbe | null | undefined): boolean {
  const enabled = user?.isGuest === true && user.licenses.includes('planning')
  const me = useApiQuery<PlanningMe>(() => planningApi.getMe(), { enabled })

  return enabled && me.data?.isApplicant === true
}
